/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Indexnow_Step_SubmitInputs */

const en_admin_indexnow_step_submit = /** @type {(inputs: Admin_Indexnow_Step_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Submit URLs`)
};

/**
* | output |
* | --- |
* | "3. Submit URLs" |
*
* @param {Admin_Indexnow_Step_SubmitInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_indexnow_step_submit = /** @type {((inputs?: Admin_Indexnow_Step_SubmitInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Indexnow_Step_SubmitInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_indexnow_step_submit(inputs)
});
export { admin_indexnow_step_submit as "admin.indexnow.step_submit" }